export default __webpack_public_path__ + "static/media/maxime.23a3ac89.jpeg";